"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StructureEditor = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = require("office-ui-fabric-react/lib/Button");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var ChangeHistory_1 = require("../../shared/ChangeHistory");
var components_1 = require("../../shared/components");
var use_structure_editor_1 = require("../hooks/use-structure-editor");
var LayerCard_1 = require("./LayerCard");
var LayerNodesTable_1 = require("./LayerNodesTable");
require("./styles/structure-editor.scss");
/**
 * StructureEditor - Panel for defining and editing the layered structure of
 * the selected strategy. Pure orchestrator: layer / node CRUD lives in
 * {@link useStructureEditor}; row rendering is delegated to {@link LayerCard}
 * and {@link LayerNodesTable}.
 */
exports.StructureEditor = function (_a) {
    var columns = _a.columns, onColumnsChange = _a.onColumnsChange, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, _c = _a.hasStrategySelected, hasStrategySelected = _c === void 0 ? true : _c, _d = _a.hasStrategies, hasStrategies = _d === void 0 ? true : _d, onLayerEditingChange = _a.onLayerEditingChange, focusedLayerIdProp = _a.focusedLayerId, onFocusedLayerChange = _a.onFocusedLayerChange, _e = _a.panelMode, panelMode = _e === void 0 ? 'structure' : _e, _f = _a.showHistory, showHistory = _f === void 0 ? true : _f;
    var _g = react_1.useState(null), internalFocusedLayerId = _g[0], setInternalFocusedLayerId = _g[1];
    var isFocusControlled = focusedLayerIdProp !== undefined;
    var focusedLayerId = isFocusControlled ? focusedLayerIdProp : internalFocusedLayerId;
    var setFocusedLayerId = react_1.useCallback(function (layerId) {
        if (!isFocusControlled) {
            setInternalFocusedLayerId(layerId);
        }
        onFocusedLayerChange === null || onFocusedLayerChange === void 0 ? void 0 : onFocusedLayerChange(layerId);
    }, [isFocusControlled, onFocusedLayerChange]);
    var editor = use_structure_editor_1.useStructureEditor(columns, onColumnsChange, onLayerEditingChange);
    var isHistoryOnlyMode = panelMode === 'history';
    react_1.useEffect(function () {
        if (isHistoryOnlyMode) {
            return;
        }
        if (!focusedLayerId) {
            return;
        }
        if (!columns.some(function (column) { return column.id === focusedLayerId; })) {
            setFocusedLayerId(null);
        }
    }, [columns, focusedLayerId, isHistoryOnlyMode, setFocusedLayerId]);
    react_1.useEffect(function () {
        if (isHistoryOnlyMode && !editor.historyOpen) {
            editor.toggleHistory();
        }
    }, [editor, isHistoryOnlyMode]);
    var getNextLayerNodes = function (currentIndex) {
        if (currentIndex >= columns.length - 1)
            return [];
        return columns[currentIndex + 1].nodes || [];
    };
    if (isHistoryOnlyMode) {
        return (react_1.default.createElement("div", { className: "structure-editor-container" },
            react_1.default.createElement(ChangeHistory_1.ChangeHistory, { title: "Strategy Builder History", changeHistory: editor.strategyHistory, isExpanded: editor.historyOpen, onToggle: editor.toggleHistory, isLoading: editor.isLoadingHistory, loadingComponent: react_1.default.createElement(components_1.SkeletonTable, { rows: 3 }), emptyMessage: "No changes recorded yet." })));
    }
    return (react_1.default.createElement("div", { className: "structure-editor-container" },
        !hasStrategySelected ? (react_1.default.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.info }, hasStrategies
            ? 'Select a strategy above to view and edit its structure.'
            : 'No strategies yet. Use "Add strategy" above to create your first one.')) : (react_1.default.createElement("div", { className: "ws-column-list" },
            isLoading ? (react_1.default.createElement(components_1.SkeletonTable, { rows: 3 })) : columns.length === 0 ? (react_1.default.createElement(MessageBar_1.MessageBar, { messageBarType: MessageBar_1.MessageBarType.info }, "No strategy levels yet. Click \"Add Strategy Level\" to create one.")) : (columns.map(function (column, index) {
                var isEditing = editor.editingColumnId === column.id;
                var isExpanded = focusedLayerId === column.id;
                return (react_1.default.createElement("div", { key: column.id, className: "ws-layer-container" },
                    react_1.default.createElement(LayerCard_1.LayerCard, { column: column, isEditing: isEditing, editingName: editor.editingColumnName, isExpanded: isExpanded, onStartEdit: function () { return editor.startColumnEdit(column); }, onCancelEdit: editor.cancelColumnEdit, onConfirmEdit: editor.confirmColumnEdit, onEditingNameChange: function (name) {
                            editor.setEditingColumnName(name);
                            onColumnsChange(columns.map(function (c) { return (c.id === column.id ? __assign(__assign({}, c), { name: name }) : c); }));
                        }, onToggleExpand: function () {
                            if (focusedLayerId === column.id) {
                                setFocusedLayerId(null);
                                return;
                            }
                            setFocusedLayerId(column.id);
                        }, onDelete: function () { return editor.deleteColumn(column.id); } }),
                    isExpanded && (react_1.default.createElement(LayerNodesTable_1.LayerNodesTable, { column: column, nextLayerNodes: getNextLayerNodes(index), onUpdateNode: function (nodeId, updates) {
                            return editor.updateNode(column.id, nodeId, updates);
                        }, onUpdateConnectionWeight: function (nodeId, targetNodeId, weightType) {
                            return editor.updateConnectionWeight(column.id, nodeId, targetNodeId, weightType);
                        }, onDeleteNode: function (nodeId) { return editor.deleteNode(column.id, nodeId); }, onAddNode: function () { return editor.addNode(column.id); } }))));
            })),
            react_1.default.createElement("div", { className: "ws-add-level-actions" },
                react_1.default.createElement(Button_1.DefaultButton, { iconProps: { iconName: 'Add' }, text: "Add Strategy Level", title: "Add a new strategy level", ariaLabel: "Add a new strategy level", className: "ws-add-button ws-admin-button-add ws-admin-button-hover-accent", onClick: editor.addColumn, disabled: isLoading })))),
        showHistory && (react_1.default.createElement(ChangeHistory_1.ChangeHistory, { title: "Strategy Builder History", changeHistory: editor.strategyHistory, isExpanded: editor.historyOpen, onToggle: editor.toggleHistory, isLoading: editor.isLoadingHistory, loadingComponent: react_1.default.createElement(components_1.SkeletonTable, { rows: 3 }), emptyMessage: "No changes recorded yet." }))));
};
